import { render, staticRenderFns } from "./ContratosDadosGerais.vue?vue&type=template&id=180100be&"
import script from "./ContratosDadosGerais.vue?vue&type=script&lang=js&"
export * from "./ContratosDadosGerais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports